import React, { useEffect, useState } from "react";
import Select, { InputActionMeta, SingleValue } from "react-select";

import { CustomSelectPropsType, SelectOptionType } from "./CustomSelectTypes";

const CustomSelect: React.FC<CustomSelectPropsType> = ({
  options = [],
  name = "",
  placeholder = "",
  label = "",
  handleFieldChange = () => {},
}) => {
  const [userTextInput, setUserTextInput] = useState("");
  const [selectedValue, setSelectedValue] =
    useState<SingleValue<SelectOptionType>>(null);

  const handleInputChange = (val: string, { action }: InputActionMeta) => {
    if (action === "input-change") {
      setUserTextInput(val);
    }
  };

  const handleSelectChange = (
    selectedOption: SingleValue<SelectOptionType>,
  ) => {
    setSelectedValue(selectedOption);
    setUserTextInput("");
  };

  useEffect(() => {
    setUserTextInput("");
    setSelectedValue(null);
  }, [options]);

  useEffect(() => {
    let type = "";
    let value: SingleValue<SelectOptionType>;

    if (!userTextInput) {
      type = "select";
      value = selectedValue;
      handleFieldChange({
        name: name,
        type: type,
        value: value,
      });
    }
  }, [userTextInput, selectedValue, handleFieldChange, name]);

  return (
    <fieldset className="md:mw-28 w-full mb-2-5">
      <label htmlFor={name} className="block f-size-1-125 color-green mb-1">
        {label}
      </label>

      <Select<SelectOptionType>
        id={`select-${name}`}
        inputValue={userTextInput}
        onInputChange={handleInputChange}
        value={selectedValue}
        onChange={handleSelectChange}
        options={options}
        placeholder={placeholder}
        noOptionsMessage={(val) => `${placeholder} ${val.inputValue} не найден`}
        isClearable={true}
        isSearchable={true}
        classNamePrefix="custom-select"
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? "white" : "white",
          }),
        }}
      />
    </fieldset>
  );
};

export default CustomSelect;
